import { Component, OnInit } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { UserService } from 'src/app/services/user-service/user.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { DashboardService } from 'src/app/services/dashboard-services/dashboard.service';
import { tap } from 'rxjs/internal/operators/tap';
import { DevicesDevicesService } from 'src/app/services/devices-services/devices-devices-services/devices-devices.service';
import { ReportsTurnsService } from 'src/app/services/turns-services/reports-turns-service/reports-turns.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  turnAccess;
  controlsAccess;
  deviceAccess;

  centers;
  selectedCenters;
  from;
  to;

  colors = [
    '#3bafda',
    '#ed5565',
    '#fcbb42',
    '#37bc9b',
    '#967adc',
    '#d770ad',
    '#ff9d00',
    '#75560d',
    '#ffe4b5',
    '#eeeeee',
    '#6d7182',
  ];
  centersStats = [];
  turnsPerTypeData;
  turnsPerDeskData;
  devicesListData;
  turnsWaitingTimeData;
  turnsAttentionTimeData;
  turnsReportsData;
  noItemsConfig;

  dashboardServiceSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private userStorageService: UserStorageService,
              private dashboardService: DashboardService,
              private devicesDevicesService: DevicesDevicesService,
              private reportsTurnsService: ReportsTurnsService,
              private userService: UserService) {
                this.centers = this.userStorageService.getCenterList();
                this.noItemsConfig = this.setNoItemsConfig();
              }

  ngOnInit() {
    this.setBreadcrumb();
    this.turnAccess = this.accessGranted('TUR');
    this.controlsAccess = this.accessGranted('CTR');
    this.deviceAccess = this.accessGranted('DEV');
    this.selectedCenters = [this.centers[0]];
    if (this.dashboardServiceSubscription) { this.dashboardServiceSubscription.unsubscribe(); }
    this.dashboardServiceSubscription = this.dashboardService.listenReloadStatistics().pipe(
      tap(o => this.selectedCenters = o['centers']),
      tap(o => this.from = o['from'].valueOf()),
      tap(o => this.to = o['to'].valueOf()),
      tap(o => this.loadData())
    ).subscribe();
  }

  private loadData() {
    this.centersStats = [];
    this.selectedCenters.forEach(sc => this.centersStats.push({
      center: sc,
      stats: {
        turnsPerDeskData: null,
        turnsPerTypeData: null,
        turnsWaitingTimeData: null,
        turnsAttentionTimeData: null,
        bestDesksData: null,
        devicesByStatusData: null,
        devicesByTypeData: null
      }
    }));

    this.centersStats.forEach(sc => {
      this._getTurnsPerType(sc.center, this.from , this.to);
      this._getTurnsPerDesk(sc.center, this.from , this.to);
      this._getWaitingTimePerDesk(sc.center, this.from, this.to);
      this._getAttentionTimePerDesk(sc.center, this.from , this.to);
      this._getBestDesks(sc.center, this.from, this.to);
      this._getDevicesByStatus(sc.center);
      this._getDevicesByType(sc.center);
    });

  }

  private _getDevicesByStatus(center) {
    this.devicesDevicesService.getDevicesByStatus(center.InternalId).pipe(
      tap(devicesByStatus => {
        const i = this.centersStats.findIndex(cs => cs.center.internalId === center.internalId);
        if (i !== -1) {
          this.centersStats[i]['stats']['devicesByStatusData'] = devicesByStatus;
        }
      })
    ).subscribe();
  }

  private _getDevicesByType(center) {
    this.devicesDevicesService.getDevicesByType(center.InternalId).pipe(
      tap(devicesByType => {
        const i = this.centersStats.findIndex(cs => cs.center.internalId === center.internalId);
        if (i !== -1) {
          this.centersStats[i]['stats']['devicesByTypeData'] = devicesByType;
        }
      })
    ).subscribe();
  }

  private _getTurnsPerType(center, from, to) {
    this.reportsTurnsService.listTurnsPerType(from, to, [center.InternalId]).pipe(
      tap((turnsPerType) => {
        const i = this.centersStats.findIndex(cs => cs.center.internalId === center.internalId);
        if (i !== -1) {
          this.centersStats[i]['stats']['turnsPerTypeData'] = turnsPerType;
        }
      })
    ).subscribe();
  }

  private _getTurnsPerDesk(center, from, to) {
    this.reportsTurnsService.listTurnsPerDesk(from, to, [center.InternalId]).pipe(
      tap((turnStatisticsPerDesk) => {
        const i = this.centersStats.findIndex(cs => cs.center.internalId === center.internalId);
        if (i !== -1) {
          this.centersStats[i]['stats']['turnsPerDeskData'] = turnStatisticsPerDesk;
        }
      }),
    ).subscribe();
  }

  private _getWaitingTimePerDesk(center, from, to) {
    this.reportsTurnsService.waitingTimePerDesk(from, to, [center.InternalId]).pipe(
      tap((turnsWaitingTime) => {
        const i = this.centersStats.findIndex(cs => cs.center.internalId === center.internalId);
        if (i !== -1) {
          this.centersStats[i]['stats']['turnsWaitingTimeData'] = turnsWaitingTime;
        }
      }),
    ).subscribe();
  }

  private _getAttentionTimePerDesk(center, from, to) {
    this.reportsTurnsService.attentionTimePerDesk(from, to, [center.InternalId]).pipe(
      tap((turnsAttentionTime) => {
        const i = this.centersStats.findIndex(cs => cs.center.internalId === center.internalId);
        if (i !== -1) {
          this.centersStats[i]['stats']['turnsAttentionTimeData'] = turnsAttentionTime;
        }
      }),
    ).subscribe();
  }

  private _getBestDesks(center, from, to) {
    this.reportsTurnsService.bestDesks(from, to, [center.InternalId]).pipe(
      tap((bestDesks) => {
        const i = this.centersStats.findIndex(cs => cs.center.internalId === center.internalId);
        if (i !== -1) {
          this.centersStats[i]['stats']['bestDesksData'] = (bestDesks as Array<any>).sort((a, b) => a.deskName.toLowerCase() > b.deskName.toLowerCase() ? 1 : -1);
        }
      }),
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-th', 'dashboard'));
  }

  public accessGranted(accessToken) {
    return this.userService.accessGranted(accessToken);
  }

  private setNoItemsConfig() {
    return {
      description: 'dashboard-page.selected centers not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }
}
